import { AccordionKey } from "./AccordionKeys.types";

export const AccordionKeys = {
  client: {
    currentAgreement: "client.currentAgreement",
    indebtedness: "client.indebtedness",
  },
  dropzone: {
    myUploads: "dropzone.myUploads",
    clientUploads: "dropzone.clientUploads",
    clientSelfUploads: "dropzone.clientSelfUploads",
  },
  notice: {
    assetInventory: "notice.assetInventory",
    relatives: "notice.relatives",
    clientNote: "notice.clientNote",
  },
} as const satisfies Record<string, Record<string, AccordionKey>>;
